import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../../utils/updateObject";

const initialState = {
  isLoading: false,
  UsersOnline: [],
  errorMsg: null,
  currentUserOnline: null,
  userConnectInfo : null
};

const usersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.USERS_START:
      return updateObject(state, {
        isLoading: true,
      });
    case actionTypes.USERS_ERROR:
      return updateObject(state, {
        isLoading: false,
        errorMsg: action.errorMsg,
      });
    case actionTypes.USERS_ONLINE_SUCCESS:
      return updateObject(state, {
        isLoading: false,
        UsersOnline: [...state.UsersOnline, ...action.UserOnline],
        currentUserOnline: action.UserOnline,
      });
    case actionTypes.USER_CONNECT_INFO:
      return updateObject(state, {
        isLoading: false,
        userConnectInfo: action.userConnectInfo
      });
    default:
      return state;
  }
};

export default usersReducer;
